var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
const SvgAmmoHeavy = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1434 1024",
  fill: "currentColor"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#b286ff",
  d: "M460.8 243.2c38.4 0 89.6 128 89.6 179.2H371.2c0-51.2 51.2-179.2 89.6-179.2M716.8 243.2c38.4 0 89.6 128 89.6 179.2H627.2c0-51.2 51.2-179.2 89.6-179.2M972.8 243.2c38.4 0 89.6 128 89.6 179.2H883.2c0-51.2 51.2-179.2 89.6-179.2M371.2 473.6h179.2V768H371.2zM627.2 473.6h179.2V768H627.2zM883.2 473.6h179.2V768H883.2z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#b286ff",
  d: "M179.2 1024 0 844.8V179.2L179.2 0h1075.2l179.2 179.2v665.6L1254.4 1024zm51.2-128h972.8l102.4-102.4V230.4L1203.2 128H230.4L128 230.4v563.2z"
})));
const Memo = /*#__PURE__*/memo(SvgAmmoHeavy);
export default Memo;